import { render, staticRenderFns } from "./EditSqc.vue?vue&type=template&id=fae440d4&scoped=true&lang=true&"
import script from "./EditSqc.vue?vue&type=script&lang=js&"
export * from "./EditSqc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae440d4",
  null
  
)

export default component.exports